import { call, put, takeEvery } from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import downloadHelper from '@/utils/downloads';
import {
  downloadRequestMarkdownError,
  fetchRequestMarkdownError,
  fetchRequestMarkdownSuccess,
} from '../actions';
import actions from '../constants';
import RequestMarkdownService from '../service';

export function* markdown({ category, code }) {
  const { response, error } = yield call(callAdapter, RequestMarkdownService.markdown(code));
  if (error) {
    yield put(fetchRequestMarkdownError(category, code, error));
  } else {
    yield put(fetchRequestMarkdownSuccess(category, code, response));
  }
}

export function* download({ code }) {
  const { response, error } = yield call(callAdapter, RequestMarkdownService.markdown(code));
  if (error) {
    yield put(downloadRequestMarkdownError(code, error));
  } else {
    downloadHelper.textDownload(response.text, `${code}_request.md`);
  }
}

export default function* requestMarkdownApi() {
  yield takeEvery(actions.FETCH_REQUEST_MARKDOWN, markdown);
  yield takeEvery(actions.DOWNLOAD_REQUEST_MARKDOWN, download);
}
